export default {"src":"/login-app/[GIT_HASH]/_next/static/media/badge.c0cd13f9.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};